import http from '@monolith/legacy/services/api/http';
import { captureLoyaltyException } from '@core/plugins/sentry/helper';
import type { AxiosResponse } from 'axios';
import type { FundedDiscountsResponse } from '../types';

const jsonApiConfigs = {
  headers: {
    Accept: 'application/vnd.api+json',
  },
};

export const getFundedDiscountOffers = async (brandUuids: string[]): Promise<FundedDiscountsResponse | null> => {
  try {
    const params = new URLSearchParams();
    brandUuids.forEach((uuid) => params.append('filter[brandUuids][]', uuid));

    const { data }: AxiosResponse<FundedDiscountsResponse> = await http().get(
      `/api/internal/v1/brand/offers?${params.toString()}`,
      jsonApiConfigs
    );
    return data;
  } catch (error) {
    captureLoyaltyException(error, [
      { label: 'component', value: 'funded-discounts/api' },
      { label: 'action', value: 'getFundedDiscountOffers' },
    ]);
    return null;
  }
};
